import MagnifyingGlassLight from '@/assets/magnifyingGlassLight.svg';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { FormEvent, useEffect, useRef } from 'react';

type SearchTermInputType = {
  placeholder: string;
  autofocus: boolean;
  value?: string;
  hideClearBtn?: boolean;
  className?: string;
  onSubmit: () => void;
  onChange: (value: string) => void;
  onClear?: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

const SearchTermInput = (data: SearchTermInputType) => {
  const { placeholder, autofocus, value, hideClearBtn, className, onSubmit, onChange, onClear, onFocus, onBlur } = data;
  const t = useTranslations();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  useEffect(() => {
    if (autofocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autofocus]);

  return (
    <div className={classNames('flex w-full items-center gap-2', className)}>
      <form onSubmit={handleSubmit} className="flex w-full items-center">
        <MagnifyingGlassLight className="mr-2 h-6 w-6 shrink-0" />
        <input
          ref={inputRef}
          type="text"
          name="searchTerm"
          className="w-full bg-transparent text-base outline-none placeholder:text-gray-400"
          value={value}
          placeholder={placeholder}
          autoComplete="off"
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        {!hideClearBtn && (
          <button type="button" onClick={onClear} className="btn underline">
            {t('general.$clear')}
          </button>
        )}
      </form>
    </div>
  );
};

export default SearchTermInput;
